import React from 'react';
import './HTMLParser.css';
import * as DOMPurify from 'dompurify';

const HTMLParser = ({ data }, ref) => (
  <div ref={ref} className="html-parser" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(data)}} />
);

export default React.memo(React.forwardRef(HTMLParser));
